import Content from '../types/enums/content';
import { ICornerEventRequest } from '../types/interfaces/event';
import Event from './event';
import ImageUtils from '../utils/image';

class Corner extends Event {
  corner: string | undefined;
  logoColor: string | undefined;
  logoWhite: string | undefined;

  constructor(request: ICornerEventRequest) {
    super({ ...request, type: Content.CORNER });
    this.corner = request.id;
    this.logoColor = ImageUtils.getImage(request.logoColor, 'logo');
    this.logoWhite = ImageUtils.getImage(request.logoBlanco, 'logo');
    this.synopsis = request.description;
  }
}

export default Corner;
